import React, { FC, useMemo } from 'react';
import { createContext } from '@shared/utils/createContext';
import { GuestSiteEventDesign } from '../layout.types';
import { useTheme } from '@withjoy/joykit';
import { deriveWebsiteColorsFromEventDesign } from '@shared/utils/websiteDesign';
import { DesignLayoutType } from '@graphql/generated';

type ColorPaletteProviderContext = {
  accentColor?: string;
  artBackgroundColor?: string;
  pageFontColor?: string;
  pageColor?: string;
  artBackgroundFontColor?: string;
  rsvpButtonColor?: string;
};

type ColorPaletteProviderProps = {
  eventDesign: GuestSiteEventDesign;
};

const [Provider, useColorPaletteProvider] = createContext<ColorPaletteProviderContext>({
  name: 'ColorPaletteProvider',
});

const ColorPaletteProvider: FC<ColorPaletteProviderProps> = ({ children, eventDesign }) => {
  const theme = useTheme();

  const ctx = useMemo<ColorPaletteProviderContext>(() => {
    if (eventDesign) {
      const derivedWebsiteColors = deriveWebsiteColorsFromEventDesign(eventDesign, eventDesign.theme);
      const rsvpButtonColor = eventDesign.websiteLayout.layoutType === DesignLayoutType.aloha ? derivedWebsiteColors.artBackgroundFontColor : derivedWebsiteColors.accentColor;

      return {
        ...derivedWebsiteColors,
        rsvpButtonColor: rsvpButtonColor || theme.colors.black,
      };
    }

    return {
      accentColor: undefined,
      artBackgroundColor: undefined,
      artBackgroundFontColor: undefined,
      pageFontColor: undefined,
      pageColor: undefined,
    };
  }, [eventDesign, theme]);

  return <Provider value={ctx}>{children}</Provider>;
};

ColorPaletteProvider.displayName = 'ColorPaletteProvider';

export { ColorPaletteProvider, useColorPaletteProvider };
